import React from "react";
import Hero from "./Hero";
import Benefits from "./Benefits";
import Visit from "./Visit";
import Best from "./Best";
import Coache from "./Coache";
import Goal from "./Goal";
import Work from "./Work";
import Gym from "./Gym";
import Crossfit from "./Crossfit";
import Our from "./Our";
import Hour from "./Hours";
import News from "./News";
import Instagram from "./Instagram";
import Footer from "./Footer";


function Home() {
  return (
    <>
      <Hero />
      <Benefits />
      <Visit />
      <Best />
      <Coache />
      <Goal />
      <Work />
      <Gym />
      <Crossfit />
      <Our />
      <Hour/>
      <News/>
      <Instagram/>
      <Footer/>
    </>
  );
}

export default Home;
